/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-bill-item.reducer';

export const PharmacyBillItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyBillItemList = useAppSelector(state => state.pharmacyBillItem.entities);
  const loading = useAppSelector(state => state.pharmacyBillItem.loading);
  const totalItems = useAppSelector(state => state.pharmacyBillItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-bill-item-heading" data-cy="PharmacyBillItemHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.home.title">Pharmacy Bill Items</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-bill-item/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.home.createLabel">Create new Pharmacy Bill Item</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyBillItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyBillItemList && pharmacyBillItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('chargedMrp')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.chargedMrp">Charged Mrp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chargedMrp')} />
                </th>
                <th className="hand" onClick={sort('qty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.qty">Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty')} />
                </th>
                <th className="hand" onClick={sort('manufacDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.manufacDate">Manufac Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('manufacDate')} />
                </th>
                <th className="hand" onClick={sort('expDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.expDate">Exp Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expDate')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('discount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.discount">Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discount')} />
                </th>
                <th className="hand" onClick={sort('paidAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.paidAmount">Paid Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paidAmount')} />
                </th>
                <th className="hand" onClick={sort('taxCode')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.taxCode">Tax Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('taxCode')} />
                </th>
                <th className="hand" onClick={sort('cessAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.cessAmount">Cess Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cessAmount')} />
                </th>
                <th className="hand" onClick={sort('exempted')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.exempted">Exempted</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exempted')} />
                </th>
                <th className="hand" onClick={sort('freeQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.freeQty">Free Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('freeQty')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.pharmacyStock">Pharmacy Stock</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.pharmacyBill">Pharmacy Bill</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.uqcType">Uqc Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.scheme">Scheme</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyBillItemList.map((pharmacyBillItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-bill-item/${pharmacyBillItem.id}`} color="link" size="sm">
                      {pharmacyBillItem.id}
                    </Button>
                  </td>
                  <td>{pharmacyBillItem.chargedMrp}</td>
                  <td>{pharmacyBillItem.qty}</td>
                  <td>{pharmacyBillItem.manufacDate}</td>
                  <td>{pharmacyBillItem.expDate}</td>
                  <td>{pharmacyBillItem.active ? 'true' : 'false'}</td>
                  <td>{pharmacyBillItem.cursor}</td>
                  <td>{pharmacyBillItem.timestampentry}</td>
                  <td>{pharmacyBillItem.microSec}</td>
                  <td>{pharmacyBillItem.lastupdated}</td>
                  <td>{pharmacyBillItem.discount}</td>
                  <td>{pharmacyBillItem.paidAmount}</td>
                  <td>{pharmacyBillItem.taxCode}</td>
                  <td>{pharmacyBillItem.cessAmount}</td>
                  <td>{pharmacyBillItem.exempted ? 'true' : 'false'}</td>
                  <td>{pharmacyBillItem.freeQty}</td>
                  <td>
                    {pharmacyBillItem.pharmacyStock ? (
                      <Link to={`/pharmacy-stock/${pharmacyBillItem.pharmacyStock.id}`}>{pharmacyBillItem.pharmacyStock.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBillItem.pharmacyBill ? (
                      <Link to={`/pharmacy-bill/${pharmacyBillItem.pharmacyBill.id}`}>{pharmacyBillItem.pharmacyBill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBillItem.uqcType ? (
                      <Link to={`/clinical-dictionary/${pharmacyBillItem.uqcType.id}`}>{pharmacyBillItem.uqcType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBillItem.scheme ? (
                      <Link to={`/payment-scheme/${pharmacyBillItem.scheme.id}`}>{pharmacyBillItem.scheme.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-bill-item/${pharmacyBillItem.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-bill-item/${pharmacyBillItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-bill-item/${pharmacyBillItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.home.notFound">No Pharmacy Bill Items found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyBillItemList && pharmacyBillItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyBillItem;
